import { add, scale, subtract } from '../game/math'
import { getTrackSample } from '../game/track'
import type { Track, Vec2 } from '../game/types'

export const TRACK_RAIL_RENDER_OFFSET = 0.9

export interface TrackRailSegment {
  key: string
  side: -1 | 1
  position: Vec2
  rotationY: number
  length: number
  height: number
  lateral: number
  accent: string
}

export function decodeRailBreak(value: number | undefined): { sampleIndex: number; side: -1 | 1 } | null {
  if (!value || !Number.isFinite(value)) return null
  return { sampleIndex: Math.abs(Math.trunc(value)) - 1, side: value < 0 ? -1 : 1 }
}

export function createTrackRailSegments(track: Track): TrackRailSegment[] {
  const lateral = track.width + TRACK_RAIL_RENDER_OFFSET
  return track.samples.flatMap((sample, index) => {
    const next = getTrackSample(track, index + 1)
    return ([-1, 1] as const).map((side) => {
      const currentEdge = add(sample.position, scale(sample.normal, lateral * side))
      const nextEdge = add(next.position, scale(next.normal, lateral * side))
      const delta = subtract(nextEdge, currentEdge)
      return {
        key: `${sample.index}:${side}`,
        side,
        position: scale(add(currentEdge, nextEdge), 0.5),
        rotationY: Math.atan2(delta.x, delta.y),
        length: Math.hypot(delta.x, delta.y),
        height: 0.62,
        lateral: lateral * side,
        accent: (Math.floor(index / 12) + (side === 1 ? 1 : 0)) % 2 === 0 ? '#4df4ff' : '#ff315f',
      }
    })
  })
}
